/**
 * Утилиты для расчёта радиуса парковок слоя "Geo Starts By Hour"
 * Включает логику интерполяции по zoom-уровню и количеству стартов
 */

/**
 * Расчёт минимального радиуса по zoom-уровню
 * Плавная интерполяция от 2px (zoom < 10) до 5px (zoom >= 15)
 * @param {number} zoom - текущий zoom-уровень карты
 * @returns {number} минимальный радиус в пикселях
 */
export const getMinRadiusByZoom = zoom => {
    if (zoom < 10) return 2;
    if (zoom >= 15) return 5;
    // Плавная интерполяция между 10 и 15
    return 2 + (zoom - 10) / (15 - 10) * (5 - 2);
};

/**
 * Расчёт радиуса парковки по количеству стартов и типу города
 * @param {number} countValue - количество стартов в парковке
 * @param {boolean} isMajorCity - является ли город большим (Москва/СПБ)
 * @param {number} minRadius - минимальный радиус (зависит от zoom)
 * @returns {number} радиус в пикселях
 */
export const calculateRadiusByCount = (countValue, isMajorCity, minRadius) => {
    if (countValue <= 0) {
        return 0;
    }

    if (isMajorCity) {
        // Большие города: 1-100 → minRadius до 100px
        return countValue <= 1
            ? minRadius
            : countValue >= 100
                ? 100
                : minRadius + ((countValue - 1) / (100 - 1)) * (100 - minRadius);
    }

    // Малые города: 1-50 → minRadius до 60px
    return countValue <= 1
        ? minRadius
        : countValue >= 50
            ? 60
            : minRadius + ((countValue - 1) / (50 - 1)) * (60 - minRadius);
};
